export enum DocumentStatusEnum {
  REQUESTED = 'REQUESTED',
  UPLOADED = 'UPLOADED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PARTIALLY_UPLOADED = 'PARTIALLY_UPLOADED',
}

export enum DocumentProcessStatusEnum {
  INITIAL = 'INITIAL',
  PRE_PROCESSING = 'PRE_PROCESSING',
  PRE_PROCESSING_FAIL = 'PRE_PROCESSING_FAIL',
  PRE_PROCESSING_SUCCESS = 'PRE_PROCESSING_SUCCESS',
  PRE_PROCESSING_RESET = 'PRE_PROCESSING_RESET',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  NO_BAR_CODE_DATA = 'NO_BAR_CODE_DATA',
  FAILED = 'FAILED',
}

export enum DocumentProcessStatusFieldsEnum {
  DRIVER_LICENSE_FRONT_PRE_PROCESSING_STATUS = 'DRIVER_LICENSE_FRONT_PRE_PROCESSING_STATUS',
  DRIVER_LICENSE_BACK_PRE_PROCESSING_STATUS = 'DRIVER_LICENSE_BACK_PRE_PROCESSING_STATUS',
  DOT_MEDICAL_PRE_PROCESSING_STATUS = 'DOT_MEDICAL_PRE_PROCESSING_STATUS',
  PRE_PROCESSING_STATUS = 'PRE_PROCESSING_STATUS',
}

export const documentProcessErrorsStatus = [
  DocumentProcessStatusEnum.FAILED,
  DocumentProcessStatusEnum.NO_BAR_CODE_DATA,
  DocumentProcessStatusEnum.PRE_PROCESSING_FAIL,
  DocumentProcessStatusEnum.PRE_PROCESSING_RESET,
];

export const readOnlyViewableStatuses = [
  DocumentStatusEnum.APPROVED,
  DocumentStatusEnum.UPLOADED,
  DocumentStatusEnum.NEEDS_REVIEW,
];
